import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { SEOProvider } from '../providers/seo-provider';
import { ScrollRestoration } from '../../components/ui/ScrollRestoration';
import { routes } from './routes';

// Root layout component that includes SEO provider
function RootLayout() {
  return (
    <SEOProvider>
      <ScrollRestoration />
      <Outlet />
    </SEOProvider>
  );
}

// Create route objects with the root layout
const routeObjects = [
  {
    path: '/',
    element: <RootLayout />,
    children: routes.map(({ title: _title, description: _description, keywords: _keywords, protected: _isProtected, ...route }) => route)
  }
];

// Create the browser router with our route configuration
const router = createBrowserRouter(routeObjects, {
  future: {
  },
});

export function AppRouter() {
  return <RouterProvider router={router} />;
}